/**
 * Join a base URL and a relative entry/file path with exactly one slash,
 * regardless of whether `base` ends with a slash or `path` starts with one.
 *
 * This is the SINGLE normalization for every "base URL + entry path -> fetch
 * URL" concat in the app (web-component entries, page HTML, artifact content).
 * The wippy/views API's `resolve_base_url` always returns a trailing slash, so
 * an ad-hoc `${base}/${path}` would otherwise produce a double slash.
 *
 * If `path` is already absolute (`http(s)://...`) or protocol-relative
 * (`//cdn/...`), it is returned unchanged and `base` is ignored — a
 * component/page may point at a CDN-hosted entry. A single leading slash
 * (`/foo`) is treated as base-relative and joined.
 */
export function joinUrl(base: string, path: string): string {
  if (/^(?:https?:)?\/\//i.test(path))
    return path
  return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
}
